export enum MedicalFields {
  Radio = 0,
  Select = 1,
  MultiSelect = 2,
  Unit = 3,
  Date = 4,
  TextArea = 5,
  Gender = 6,
  SelectApi = 7,
  SelectWithInputs = 8,
  Prescription = 9,
  Appointment = 10,
  TextEditor = 11,
  MultiFile = 12,
  File = 13,
  Option = 14,
  Number = 15,
  Text = 16,
  Warning = 17,
  CurrentDateTime = 18,
  Paragraph = 19,
  PastDate = 20,
  FutureDate = 21,
  Repeater=22,
  Statistics = 23
}

export enum MedicalKeys {
  Gender = "Gender",
  Allergens = "Allergens",
  Diseases = "Diseases",
  FamilyHistory = "Families",
  Surgeries = "Surgeries",
  LivingStatus = "LivingStatus",
  Treatments = "Treatments",
  Medications = "Medications",
  Diagnosis = "Diagnosis",
  Weight = "Weight",
  DateOfPregnancy = "DateOfPregnancy",
  IsPregnancy = "IsPregnancy",
  LMP="LMP",
  GestationalAge="GestationalAge",
  EDD="EDD",
  Cesarean="Cesarean"
}
